import styled from 'styled-components';
import { Link } from 'react-router-dom';


export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
  min-height: 100vh;
  box-sizing: border-box;
  padding-top: 10vh;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    padding-top: 10vh;
  }

  @media (max-height: 600px) {
    padding-top: 5vh;
  }
`;

export const Title = styled.h1`
  font-size: 50px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 40px; // 모바일 화면에서 글자 크기 줄임
  }
`;

export const Subtitle = styled.p`
  font-size: 20px;
  margin-bottom: 20px;
  text-align: center;
  color: #666;

  @media (max-width: 768px) {
    font-size: 18px; // 모바일 화면에서 글자 크기 줄임
    margin-bottom: 15px;
  }
`;

export const ErrorMessage = styled.div`
  color: #d32f2f;
  background-color: #ffcdd2;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: bold;
`;

export const BlogLink = styled.a`
  display: flex;
  align-items: center;
  gap: 5px;
  color: #666;
  text-decoration: none;
  font-size: 18px;
  font-weight: 500;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: #333;
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const TopLinkGroup = styled.nav`
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1000;

  @media (max-width: 768px) {
    top: 14px;
    right: 14px;
    gap: 4px;
  }
`;

export const HomeActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin: 0 0 20px;
`;

export const HomeActionLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 42px;
  padding: 0 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.84);
  border: 1px solid rgba(100, 84, 148, 0.18);
  color: #4a3b70;
  font-weight: 800;
  text-decoration: none;
  box-shadow: 0 8px 22px rgba(57, 45, 97, 0.12);
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;

  &:hover {
    background: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 12px 26px rgba(57, 45, 97, 0.16);
  }

  @media (max-width: 420px) {
    width: 100%;
  }
`;

export const DiscoverySection = styled.section`
  width: 100%;
  max-width: 640px;
  margin: 32px 0 48px;
`;

export const DiscoveryHeading = styled.h2`
  margin: 0 0 8px;
  color: #30264c;
  font-size: 24px;
  text-align: center;
`;

export const DiscoveryIntro = styled.p`
  margin: 0 0 18px;
  color: #665f74;
  text-align: center;
`;

export const DiscoveryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const DiscoveryCard = styled(Link)`
  padding: 16px;
  border: 1px solid rgba(100, 84, 148, 0.16);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.88);
  color: #30264c;
  text-decoration: none;
  box-shadow: 0 8px 24px rgba(57, 45, 97, 0.09);
  transition: transform 0.18s ease, box-shadow 0.18s ease;

  &:hover, &:focus-visible {
    transform: translateY(-3px);
    box-shadow: 0 12px 28px rgba(57, 45, 97, 0.15);
  }

  strong, span {
    display: block;
  }

  span {
    margin-top: 8px;
    color: #70677f;
    font-size: 14px;
    line-height: 1.5;
  }
`;
